import React, { useState, useEffect } from 'react';
import { X, RotateCcw, Phone, Headphones } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { IntakeReview } from './experience/IntakeReview';
import { VoicePanel } from './experience/VoicePanel';
import { useLawyahVoice } from '../hooks/useLawyahVoice';

export default function ChatWidget() {
  const { lang } = useLang(), es = lang === 'es';
  const [open, setOpen] = useState(false), [review, setReview] = useState(false);
  const voice = useLawyahVoice(lang), endVoice = voice.end;
  const close = () => { if (voice.active) endVoice(); setOpen(false); };
  useEffect(() => {
    const show = () => { setReview(false); setOpen(true); };
    window.addEventListener('lawyah-open-chat', show);
    return () => window.removeEventListener('lawyah-open-chat', show);
  }, []);
  useEffect(() => {
    const escape = event => { if (event.key === 'Escape' && open) { endVoice(); setOpen(false); } };
    window.addEventListener('keydown', escape);
    return () => window.removeEventListener('keydown', escape);
  }, [endVoice, open]);
  const reset = () => { voice.reset(); setReview(false); };
  return <>
    {open && <section className="floating-chat voice-only-widget" aria-label={es ? 'Llamada con Lawyah' : 'Call Lawyah'} data-testid="chat-panel">
      <header className="chat-header">
        <div className="chat-brand"><Headphones size={21} /><div><strong>Lawyah</strong><span data-testid="voice-agent-identity">{es ? 'Recepcionista de IA' : 'AI receptionist'}</span></div></div>
        <div className="flex gap-1">
          <button onClick={reset} disabled={voice.active || voice.saveStatus === 'saving' || voice.saveStatus === 'error'} title={es ? 'Nueva llamada' : 'New call'} aria-label={es ? 'Nueva llamada' : 'New call'} className="icon-button" data-testid="chat-reset-button"><RotateCcw size={16} /></button>
          <button onClick={close} aria-label={es ? 'Cerrar y finalizar llamada' : 'Close and end call'} className="icon-button" data-testid="chat-close-button"><X size={19} /></button>
        </div>
      </header>
      {review ? <IntakeReview key={voice.sessionId} sessionId={voice.sessionId} lang={lang} onBack={() => setReview(false)} onNew={reset} /> : <VoicePanel voice={voice} lang={lang} onReview={() => setReview(true)} />}
    </section>}
    <button onClick={() => open ? close() : setOpen(true)} className="chat-launcher call-now-launcher" aria-label={es ? 'Llamar ahora' : 'Call now'} aria-expanded={open} data-testid="chat-toggle-button">
      {open ? <X size={20} /> : <Phone size={20} />}<span>{es ? 'Llamar ahora' : 'Call now'}</span>
    </button>
  </>;
}